import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { ArrowRight } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { services } from '../mock/mock';

const Services = () => {
  const { t, lang } = useApp();
  return (
    <section id="services" className="py-20 bg-[color:var(--brand-muted)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-3xl mb-12">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-[color:var(--brand-dark)]">{t('services.title')}</h2>
          <p className="mt-4 text-gray-500 leading-relaxed">{t('services.subtitle')}</p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-6">
          {services.map((s) => {
            const Icon = Icons[s.icon] || Icons.Car;
            const loc = s[lang] || s.en;
            return (
              <div key={s.id} className="card-hover group bg-white rounded-2xl p-5 sm:p-7 flex flex-col">
                <div className="flex items-start justify-between">
                  <div className="w-14 h-14 rounded-xl flex items-center justify-center mb-5 transition-colors group-hover:bg-[color:var(--brand-dark)]" style={{ backgroundColor: 'var(--brand-muted)' }}>
                    <Icon className="w-7 h-7 text-[color:var(--brand-dark)] group-hover:text-[color:var(--brand-accent)] transition-colors" />
                  </div>
                  {s.soon && <span className="text-[11px] font-bold px-2.5 py-1 rounded-full bg-gray-100 text-gray-500">{t('services.soon')}</span>}
                </div>
                <h3 className="font-bold text-lg text-[color:var(--brand-dark)] mb-2">{loc.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed flex-1">{loc.desc}</p>
                {!s.soon && (
                  <Link to={`/guide/service-${s.id}`} className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-[color:var(--brand-dark)] hover:gap-2.5 transition-all" data-testid={`service-more-${s.id}`}>
                    {t('services.readMore')} <ArrowRight className="w-4 h-4" style={{ color: 'var(--brand-accent-hover)' }} />
                  </Link>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
